import { Link } from "react-router";
import { ChevronIcon } from "@/components/Icon";
import { buildToggleRowHref, type QuestsSearchParams } from "./questsUrl";
import styles from "./TemplateToggle.module.css";

// Expansion rides in the URL rather than client state, the same way `tab`,
// `new` and `edit` already do here. It survives the re-render after an archive,
// costs the table no "use client", and a half-open listing stays shareable.
//
// Only the title cell toggles, not the whole row: the row also carries Edit and
// Archive, and a clickable <tr> would either swallow their clicks or need them
// stopped — and it is not reachable by keyboard without extra work.
type TemplateToggleProps = {
  id: number;
  title: string;
  searchParams: QuestsSearchParams;
  openKeys: readonly string[];
  hasRungs: boolean;
};

export const TemplateToggle = ({
  id,
  title,
  searchParams,
  openKeys,
  hasRungs,
}: TemplateToggleProps) => {
  const isOpen = openKeys.includes(String(id));

  return (
    // Link rather than a bare anchor: a plain href reloads the document, and
    // tearing the page down to show a panel built from rungs the server has
    // already grouped is the most expensive way to render it. `replace`
    // because opening and closing a row is one state, not a trail of history
    // entries the back button has to walk out of.
    <Link
      to={buildToggleRowHref(searchParams, id)}
      replace
      preventScrollReset
      className={styles.toggle}
      aria-expanded={isOpen}
      data-open={isOpen || undefined}
    >
      <ChevronIcon size={12} />
      <span className={styles.title}>{title}</span>
      <span className={styles.count}>{hasRungs ? null : "no rungs"}</span>
    </Link>
  );
};
